import { LangSwitcher } from './LangSwitcher.js';
import { OrgSwitcher } from './OrgSwitcher.js';
import { UserMenu } from './UserMenu.js';

export function Header() {
  return (
    <header className="flex items-center justify-between border-b bg-white px-4 py-3">
      <div className="flex items-center gap-3">
        <strong>account-manager</strong>
        <OrgSwitcher />
      </div>
      <div className="flex items-center gap-3">
        <LangSwitcher />
        <UserMenu />
      </div>
    </header>
  );
}
